module.exports = __webpack_public_path__ + "img/C_299.dc6b32ea.png";